import { RichUtils } from 'draft-js';

export default () => {
  return {
    customStyleMap: {
      HIGHLIGHT_NOT_OK: {
        // background: "#ffaa11",
        color: '#ff8c00',
        fontWeight: 'bold',
      }
    },
    // keyBindingFn: e => {
    //   if (e.metaKey && e.key === "h") {
    //     return "highlight_ok";
    //   }
    // },
    handleKeyCommand: (command, editorState, { setEditorState }) => {
      if (command === "highlight_not_ok") {
        setEditorState(RichUtils.toggleInlineStyle(editorState, "HIGHLIGHT_NOT_OK"));
        return true;
      }
    }
  };
};
